import { FC } from 'react';
import React from 'react';
import { useCallback } from 'react';
import { useState } from 'react';
import Select from 'react-select';
import { ButtonLink } from '../../../_shared/ButtonLink.js';
import { Dropdown } from './components/Dropdown.js';
import { styles } from './styles.js';
import { StaticProps } from './types.js';

const staticProps: StaticProps = {
  components: {
    DropdownIndicator: null,
    IndicatorSeparator: null,
  },
  styles,
};

interface Option {
  value: string;
  label: string;
}

export interface Props {
  value: Option | null;
  options: Option[];
  onChange: (value: Option) => void;
  className?: string;
}

export const SelectSortBy: FC<Props> = ({
  value,
  onChange,
  options,
  className,
}) => {
  const [isOpen, setOpen] = useState(false);

  const toggleOpen = useCallback(() => {
    setOpen(!isOpen);
  }, [isOpen]);

  const onSelectChange = useCallback(
    (val: any) => {
      toggleOpen();
      onChange(val);
    },
    [onChange, toggleOpen],
  );

  return (
    <Dropdown
      isOpen={isOpen}
      onClose={toggleOpen}
      target={
        <ButtonLink onClick={toggleOpen} className={className}>
          {value ? value.label : ''}
        </ButtonLink>
      }
    >
      <Select
        autoFocus={false}
        backspaceRemovesValue={false}
        components={staticProps.components}
        controlShouldRenderValue={false}
        hideSelectedOptions
        isClearable={false}
        isSearchable={false}
        menuIsOpen
        onChange={onSelectChange}
        options={options}
        styles={staticProps.styles}
        tabSelectsValue={false}
        value={value}
      />
    </Dropdown>
  );
};
